import { render, staticRenderFns } from "./deptList.vue?vue&type=template&id=48a53199&scoped=true&"
import script from "./deptList.vue?vue&type=script&lang=js&"
export * from "./deptList.vue?vue&type=script&lang=js&"
import style0 from "./deptList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./deptList.vue?vue&type=style&index=1&id=48a53199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a53199",
  null
  
)

export default component.exports